import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import deliveryZonesStore from '../../stores/deliveryZonesStore';
import { DELIVERY_ZONE_TYPE, IDeliveryZone } from 'src/types/deliveryManagment';
import { boundsToPath } from 'src/utils/formatter';
import { Circle } from 'src/view/components/Map/Circle/Circle';
import { Polygon } from 'src/view/components/Map/Polygon/Polygon';

interface Props {
  zone: IDeliveryZone;
  index: number;
}

const DeiveryZoneMapArea = observer((props: Props) => {
  const onClick = useCallback(() => {
    deliveryZonesStore.selectZone(props.zone);
  }, []);

  if (props.zone.type === DELIVERY_ZONE_TYPE.RADIUS) {
    if (!props.zone.branch || !props.zone.radius) return null;
    return (
      <Circle<IDeliveryZone>
        allowFloat
        index={props.index}
        onSelect={onClick}
        value={props.zone}
        radius={Number(props.zone.radius)}
        color={deliveryZonesStore.getColor(props.zone)}
        center={{
          lat: props.zone.branch?.latitude,
          lng: props.zone.branch?.longitude,
        }}
      />
    );
  }

  return (
    <>
      <Polygon index={props.index} onClick={onClick} color={deliveryZonesStore.getColor(props.zone)} paths={boundsToPath(props.zone.bounds)} />
    </>
  );
});

export default DeiveryZoneMapArea;
